import { useState } from "react"
import { Temporal } from "@imago/api-client"
import { SubmitButton, MutateButton, GoButton } from "@imago/api-client-for-react"
import { useFakeSubmitGAHTBloodResults, useLastGAHTBloodResults, useSubmitGAHTBloodResults } from "../../../api.ts"
import { useNow } from '../../../queries/Now.ts'

const MAX_FILES = 9

const QUESTIONS = [
	'If applicable: How long before your test you applied your hormone gel?',
	'If applicable: What’s the date of your last hormone injection?',
	'If you are currently taking Spironolactone: Please share a blood pressure reading',
]

function _TakeBloodTests() {
	const submitFiles = useSubmitGAHTBloodResults()

	const [files, setFiles] = useState<File[]>([])

	function addFiles(newFiles: File[]) {
		setFiles(files.concat(newFiles))
	}
	function removeFile(file: File) {
		setFiles(files.filter(f => f !== file))
	}

	return <form onSubmit={ev => {
		if (!(files.length && files.length <= MAX_FILES)) ev.preventDefault()
	}} className="send-emr">
		<GoButton href="https://www.imago.tg/faq/#blood-tests" target="_blank">See the list of required diagnostics</GoButton>
		<p>Note: We require an original results sheet issued by the lab (PDF or photo-scan are sufficient).</p>
		{files.length
			? <ul className="files">
				{files.map((file, i) => (
					<li key={i}>
						<span title={file.name}>{file.name}</span>
						<button type="button" title="Remove" onClick={ev => {
							ev.preventDefault()
							removeFile(file)
						}}>
							<span className="material-symbols-outlined">delete</span>
						</button>
					</li>
				))}
			</ul>
			: <></>
		}
		{files.length < MAX_FILES ?
			<label role="button" className={files.length ? '' : 'high-prio'}>
				Add files
				<input type="file" multiple onChange={ev => {
					ev.preventDefault()
					const input = ev.target
					addFiles(Array.from(input.files!))
					input.value = ''
				}}/>
			</label>
		:
			<p>
				You can upload at most {MAX_FILES} files.{" "}
				{files.length > MAX_FILES ? <strong>Please remove some of the above.</strong> : <></>}
			</p>
		}
			{QUESTIONS.map((q, i) =>
				<label className="high-label" key={i}>
					<span>{q}</span>
					<input type="text" name={`q${i}`}/>
				</label>
			)}
			<SubmitButton
				mutation={submitFiles}
				vars={data => {
					let qa = ''
					for (const [i, q] of QUESTIONS.entries()) {
						qa += q + '\n' + data.get(`q${i}`) + '\n\n'
					}
					const qatxt = new Blob([qa], {type: 'text/plain'}) as File
					// @ts-ignore
					qatxt.name = 'qa.txt'
					return {files: [...files, qatxt]}
				}}
			>
				Submit
			</SubmitButton>
	</form>
}

export function useBloodTestsTaken() {
	const lastBloodResults = useLastGAHTBloodResults()
	const now = useNow('hour')
	if (lastBloodResults === undefined) return
	return !!lastBloodResults && Temporal.Instant.compare(lastBloodResults, now.subtract({months: 1}).toInstant()) > 0
}

export function TakeBloodTests() {
	const fakeSubmitFiles = useFakeSubmitGAHTBloodResults()
	const done = useBloodTestsTaken()
	return <section data-done={done ? true : undefined}>
		<hgroup>
			<h2>Take blood tests</h2>
			{!done ?
				<MutateButton className="secondary" mutation={fakeSubmitFiles}>TEST: Skip</MutateButton>
			: <></>}
		</hgroup>
		{!done ? <_TakeBloodTests/> : <></>}
	</section>
}
